import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";

export default function LegalPage({ contentKey }) {
  const { t, lang, dict } = useI18n();
  const sections = dict[contentKey]?.sections || [];

  return (
    <article
      data-testid={`legal-page-${contentKey}`}
      className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16"
    >
      <p className="text-xs font-mono uppercase tracking-widest text-blue-400 mb-3">
        {t("legal.lastUpdatedLabel")}: {t("legal.lastUpdated")}
      </p>
      <h1 className="text-3xl sm:text-4xl font-bold text-white tracking-tight mb-6">
        {t(`${contentKey}.title`)}
      </h1>
      <p className="text-slate-300 leading-relaxed mb-10">
        {t(`${contentKey}.intro`)}
      </p>

      {sections.length > 0 && (
        <>
          <div className="mb-10 border border-slate-800 rounded-lg p-5 bg-slate-900">
            <div className="text-xs font-mono uppercase tracking-widest text-blue-400 mb-3">
              {t("legal.tableOfContents")}
            </div>
            <ol className="space-y-1.5 text-sm text-slate-300">
              {sections.map((s, i) => (
                <li key={i}>
                  <a
                    href={`#sec-${i}`}
                    className="hover:text-white transition-colors"
                  >
                    {s.title}
                  </a>
                </li>
              ))}
            </ol>
          </div>

          <div className="space-y-8">
            {sections.map((s, i) => (
              <section key={i} id={`sec-${i}`}>
                <h2 className="text-xl font-semibold text-white mb-2">
                  {s.title}
                </h2>
                <p className="text-slate-300 leading-relaxed">{s.body}</p>
              </section>
            ))}
          </div>
        </>
      )}

      <div className="mt-12">
        <Link
          to={`/${lang}`}
          data-testid="legal-back-home"
          className="inline-flex items-center gap-2 text-blue-400 hover:text-blue-300 transition-colors"
        >
          ← {t("legal.backHome")}
        </Link>
      </div>
    </article>
  );
}
